/* eslint-disable no-unused-vars */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Chip,
  InputLabel,
  Dialog,
  Box,
  FormControlLabel,
  FormGroup,
  FormControl,
  DialogActions,
  Button,
} from '@mui/material';
import { Switch } from 'app/components/v2';
import { updateUserSettings } from 'app/store/features/userSettingsSlice';
import { ColorsV2 } from 'app/constants/color';
import { Buttons } from 'app/constants/sizing';

const WidgetsModal = props => {
  const { setSelected, selected, setIsOpen, initial, open } = props;
  const dispatch = useDispatch();
  let setting = {};
  try {
    setting = JSON.parse(JSON.parse(localStorage.getItem('user')).settings);
  } catch {
    setting = {};
  }
  const { darkmode } = useSelector(state => state.dark);
  const { t } = useTranslation('translation', { keyPrefix: 'addUser_headings' });
  const handleSwitchChange = (key, checked) => {
    setSelected(prevStates => ({
      ...prevStates,
      [key]: { ...prevStates[key], visibility: checked }
    }));
  };

  const handleCancel = () => {
    setSelected(initial);
    setIsOpen(false);
  };

  const handleSave = () => {
    dispatch(updateUserSettings({ key: 'selected', value: selected }));
    setSelected(selected);
    setIsOpen(false);
  };


  return (
    <>
      <Dialog open={open} onClose={handleCancel}>
        <Box
          sx={{
            padding: 4,
            width: '500px',
            position: 'relative',
            background: ColorsV2.secondary,
          }}
        >
          <InputLabel
            sx={{
              margin: '0 0 15px',
              fontSize: '25px',
              fontWeight: '400',
              color: ColorsV2.white,
              textAlign: 'center',
            }}
          >
            {t('widgets')}
          </InputLabel>

          {Object.entries(selected || {}).map(([key, option]) => {
            return (
              <FormControl key={key} sx={{ display: 'block' }} variant='standard'>
                <FormGroup sx={{ display: 'block' }}>
                  <FormControlLabel
                    sx={{
                      fontSize: '20px',
                      lineHeight: '25px',
                      width: '100%',
                      margin: '0 0 20px',
                      justifyContent: 'space-between',
                      color: ColorsV2.white,
                    }}
                    control={
                      <Switch
                        checked={option?.visibility}
                        handlechange={() => handleSwitchChange(key, !option?.visibility)}
                      />
                    }
                    label={t(`${key}`)}
                    labelPlacement='start'
                  />
                </FormGroup>
              </FormControl>
            );
          })}

          <DialogActions>
            <Button name='Cancel' onClick={handleCancel} sx={{ ...Buttons.baseStyle.primaryButtonLowPriority }}>
              {t('cancel')}
            </Button>

            <Button name='Save' onClick={handleSave} sx={{ ...Buttons.baseStyle.primaryButtonHighPriority }}>
              {t('save')}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default WidgetsModal;
